const tNamespace = "error:surveys."

export const SURVEY_API_ERROR_MESSAGES = {
    GET: `${tNamespace}get-surveys-failed`,
    CREATE: `${tNamespace}create-survey-failed`,
    UPDATE: `${tNamespace}update-survey-failed`,
    DELETE: `${tNamespace}delete-survey-failed`
}
